import { createContext, useContext } from "react";
const AttachmentResolverContext = createContext(null);
export const AttachmentResolverProvider = AttachmentResolverContext.Provider;
export function useAttachmentResolver() {
    const resolver = useContext(AttachmentResolverContext);
    if (!resolver) {
        throw new Error("useAttachmentResolver must be used within an AttachmentResolverProvider");
    }
    return resolver;
}
//# sourceMappingURL=AttachmentResolverContext.js.map